// extracted by mini-css-extract-plugin
export default {"policies":"policies___TTUjk","policy":"policy___vhAsG","title":"title___QAvFL","pre":"pre___O5HiU","empty":"empty___gHsj4","block":"block___cWr7w"};